import { createSlice } from "@reduxjs/toolkit";

export const redirectSlice = createSlice({
    name: "routeRedirect",
    initialState: {
        redirectionPage: null,
    },
    reducers: {
        setRedirectionPage: (state, action) => {
            state.redirectionPage = action.payload;
        },
    },
});

export const { setRedirectionPage } = redirectSlice.actions;

export const selectRedirectionPage = (state) => state.routeRedirect.redirectionPage;

export default redirectSlice.reducer;
